import { applicationService } from 'services/application';
import { ANDROID_APP_ID } from 'constants/platform';

export function isAndroid(): boolean {
  const appPlatform = applicationService.getApplicationId() ?? '0';
  return appPlatform === ANDROID_APP_ID;
}

export function isIos(): boolean {
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}
